module.exports = __webpack_public_path__ + "img/arrow-right.1d1dba62.svg";